export default "__VITE_ASSET__y6T3rCml__"